
import createEmotion from 'create-emotion';

// create our own implementation of emotion so we can use NONCE
export const {
  flush,
  hydrate,
  cx,
  merge,
  getRegisteredStyles,
  injectGlobal,
  keyframes,
  css,
  sheet,
  cache,
} = createEmotion({ nonce: process.env.NONCE });